import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ApiService } from '../common/services/api.service';
import { UtilsService } from '../common/services/utils.service';
import { DxDataGridComponent, DxListComponent, DxDrawerComponent, DxSelectBoxComponent, DxNumberBoxComponent} from 'devextreme-angular';
import { environment } from '../../environments/environment';
import CustomStore from 'devextreme/data/custom_store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WindowService } from '../common/services/window.service';
import { Router } from '@angular/router';
import { StorageService } from '../common/services/storage.service';
import { AuthService } from '../common/services/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare var test: any;

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit, AfterViewInit {
  dataSource: any = {};
  dataSource2: any = {};
  settings: any = {
    'searchProfiles': null
  };
  inventory: any = {results: []};
  inventoryColumns: Array<any>;
  gridInited = false;
  selectedItems: Array<string> = [];
  selectedItemsKeys: Array<string> = [];

  lablist: Array<string>; // = ['PRM', 'GIA', 'EGL', 'HRD', 'IGI'];
  lablistSelectedItems: any[] = [];

  params: any;
  orderby1: string;
  orderby2: string;
  orderby3: string;
  orderby4: string;
  orderdir1: string;
  orderdir2: string;
  orderdir3: string;
  orderdir4: string;
  // weightFrom: number = null;
  // weightTo: number = null;
  colors: Array<any> = [];
  clarities: Array<any> = [];
  pageSize = 150;

  filter: any;

  headers2: object = {
    'Accept': 'html/text',
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*'
  };
  isModalVisible = false;
  urlSafe: SafeResourceUrl;
  lastUpdate = '';
  showFilterModal = false;

  @ViewChild('labListComponent') labListComponent: DxListComponent;
  @ViewChild('gridContainer') gridContainer: DxDataGridComponent;
  @ViewChild(DxDrawerComponent) drawer: DxDrawerComponent;
  @ViewChild('colorFrom') colorFrom: DxSelectBoxComponent;
  @ViewChild('colorTo') colorTo: DxSelectBoxComponent;
  @ViewChild('clarityFrom') clarityFrom: DxSelectBoxComponent;
  @ViewChild('clarityTo') clarityTo: DxSelectBoxComponent;
  @ViewChild('weightFrom') weightFrom: DxNumberBoxComponent;
  @ViewChild('weightTo') weightTo: DxNumberBoxComponent;


  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient,
    private window: WindowService, private router: Router,
    private storageService: StorageService,
    public authService: AuthService, private sanitizer: DomSanitizer) {

      this.selectedItems = JSON.parse(localStorage.getItem('selectedItems')) || [];

      this.dataSource.store = new CustomStore({

      load: function (loadOptions: any) {
          let params = '?';
          let orderBy = '';

          let filter: string = window.nativeWindow.filter || {};

          params += 'skip=' + loadOptions.skip || 0;
          params += '&take=' + loadOptions.take || this.pageSize;

          filter = Object.keys(filter).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(filter[key]);
          }).join('&') || 'firstLoad=1';

          if (loadOptions.sort) {
            loadOptions.sort.forEach((item: any , i: number) => {
              // sort
              if (['Shape', 'Color', 'Cut', 'Clarity', 'Lab', 'Polish', 'Fluorescence', 'Polish', 'Symmetry', 'Fluorescence'].includes(loadOptions.sort[i].selector)) {
                orderBy = loadOptions.sort[i].selector + 'OrderBy';
              } else {
                orderBy = loadOptions.sort[i].selector;
              }

              // sorting
             params += '&orderby' + (i + 1) + '=' + orderBy;
              if (loadOptions.sort[i].desc) {
                params += '&orderdir' + (i + 1) + '=desc';
              } else {
                params += '&orderdir' + (i + 1) + '=asc';
              }
            });
          }
          return httpClient.post(`${environment.api}/inventory.asp` + params, filter,
          {
            headers: new HttpHeaders({
              'Accept': 'html/text',
              'Content-Type': 'application/x-www-form-urlencoded',
              'Access-Control-Allow-Origin': '*'
            })
           }
          )
          .toPromise()
          .then((data: any) => {
            // this.authService.checkLoginFromResponse(data);

            if (data.isLoggedIn === 0) {
              console.log('################ Logged Out ##################');
              window.nativeWindow.location.href = '/';
              // window.nativeWindow.location.href = 'http://mikezeevi.fantasy.mn/';
            }
              return {
                  data: data.items || [],
                  totalCount: data.totalCount || 0
              };
          }
          )
          .catch(error => {
            throw error('Data Loading Error');
        });
      }
  });
  }

  ngOnInit() {
    test = this;
  }

  ngAfterViewInit() {
    this.weightTo.value = null;
    this.weightFrom.value = null;
    this.getSettings();

  }

  getSettings (): any {
    return this.apiService.get('settings.asp', false).then((settings: any) => {
        settings = UtilsService.checkIfJSON(settings);
        this.lastUpdate = settings['lastUpdate'] || [];
        this.params = settings['params'] || [];

        this.colors = settings['colors'] || [];
        this.clarities = settings['clarities'] || [];

        this.orderby1 = settings.searchProfiles['Order1'] ? settings.searchProfiles['Order1'] : 'Weight';
        this.orderdir1 = settings.searchProfiles['OrderDir1'];
        this.orderby2 = settings.searchProfiles['Order2'] ? settings.searchProfiles['Order2'] : 'Shape';
        this.orderdir2 = settings.searchProfiles['OrderDir2'];
        this.orderby3 = settings.searchProfiles['Order3'] ? settings.searchProfiles['Order3'] : 'Shape';
        this.orderdir3 = settings.searchProfiles['OrderDir3'];
        this.orderby4 = settings.searchProfiles['Order4'] ? settings.searchProfiles['Order4'] : 'Shape';
        this.orderdir4 = settings.searchProfiles['OrderDir4'];

        settings.searchProfiles = settings.searchProfiles || {};

        this.inventoryColumns = settings['inventoryColumns'];

        // set default sort by 1 and 2
        // const orderby1Indx = this.inventoryColumns.findIndex((x) => {
        //   if (x.sortOrder === this.orderby1) {
        //     return x;
        //   }
        // });

        // const orderby2Indx = this.inventoryColumns.findIndex((x) => {
        //   if (x.sortOrder === this.orderby2) {
        //     return x;
        //   }
        // });

        // this.inventoryColumns[orderby1Indx].sortOrder = !!this.orderby1 ? 'asc' : 'desc';
        // this.inventoryColumns[orderby1Indx].sortIndex = 0;
        // this.inventoryColumns[orderby2Indx].sortOrder = !!this.orderby2 ? 'asc' : 'desc';
        // this.inventoryColumns[orderby1Indx].sortIndex = 1;

        localStorage.setItem('inventoryColumns', JSON.stringify(settings['inventoryColumns']));

        this.filter = this.setFilter();

        // this.gridContainer.instance.columnOption(this.orderby1, { sortOrder: 'asc', sortIndex: 0});
        // this.gridContainer.instance.columnOption(this.orderby2, { sortOrder: 'asc', sortIndex: 1});

        this.window.nativeWindow.filter = this.filter;
        this.gridContainer.instance.refresh();
        this.gridInited = true;

    }).catch(function (err) {
      console.log(err);
    });
  }

  setFilter() {
    console.log('setFilter');

    // COLOR
    // if not both FULL or EMPTY, ie: [null,null] or ["1","4"])
    if (!!(this.colorFrom.selectedItem && this.colorTo.selectedItem) || !(!this.colorFrom.selectedItem && !this.colorTo.selectedItem)) {

      // [1, null]
      if (this.colorFrom.selectedItem && !this.colorTo.selectedItem) {
        this.colorTo.value = this.colorFrom.selectedItem.id;
      }
      // [null, 1]
      if (!this.colorFrom.selectedItem && this.colorTo.selectedItem) {
        this.colorTo.value = this.colorTo.selectedItem.id;
      }
      // [4,1] - swap - "from" bigger than "to"
      if ( Number(this.colorFrom.selectedItem.id) > Number(this.colorTo.selectedItem.id)) {
        const c = Number(this.colorFrom.selectedItem.id);
        this.colorFrom.value = this.colorTo.selectedItem.id;
        this.colorTo.value = String(c);
      }
    }

    // CLARITY
    // if not both FULL or EMPTY, ie: [null,null] or ["1","4"])
    if (!!(this.clarityFrom.selectedItem && this.clarityTo.selectedItem) || !(!this.clarityFrom.selectedItem && !this.clarityTo.selectedItem)) {

      // [1, null]
      if (this.clarityFrom.selectedItem && !this.clarityTo.selectedItem) {
        this.clarityTo.value = this.clarityFrom.selectedItem.id;
      }
      // [null, 1]
      if (!this.clarityFrom.selectedItem && this.clarityTo.selectedItem) {
        this.clarityTo.value = this.clarityTo.selectedItem.id;
      }
      // [4,1] - swap - "from" bigger than "to"
      if ( Number(this.clarityFrom.selectedItem.id) > Number(this.clarityTo.selectedItem.id)) {
        const c = Number(this.clarityFrom.selectedItem.id);
        this.clarityFrom.value = this.clarityTo.selectedItem.id;
        this.clarityTo.value = String(c);
      }
    }

    const filter = {
      'weightFrom': this.weightFrom.value || 0,
      'weightTo': this.weightTo.value || 1000,
      'colorFrom': this.colorFrom.selectedItem ? this.colorFrom.selectedItem.id : '',
      'colorTo': this.colorTo.selectedItem ? this.colorTo.selectedItem.id : '',
      'clarityFrom':  this.clarityFrom.selectedItem ? this.clarityFrom.selectedItem.id : '',
      'clarityTo': this.clarityTo.selectedItem ? this.clarityTo.selectedItem.id : '',
    };
    console.log(filter);
    // setFilter
    return filter;
  }

  selectItem (key: string) {
  }

  refreshInventory() {
    if ( this.gridInited ) {
      this.filter = this.setFilter();
      this.window.nativeWindow.filter = this.filter;
      this.gridContainer.instance.refresh();
    }

    this.showFilterModal = false;
  }

  resetInventory($event: Event) {

  }

  toggleSF() {
    this.drawer.instance.toggle();
  }

  addItemsToRequest() {
    // this.selectedItems = this.gridContainer.selectedRowKeys.map((x) => {
    //   return x.LotIDStr.replace(' ', '');
    // });

    if ( this.gridContainer.selectedRowKeys.length > 0) {
      this.storageService.setItem('selectedItems', JSON.stringify(this.gridContainer.selectedRowKeys));
      this.router.navigate(['/main/request']);
    }
  }

  selectItems(event: any) {
    console.log('selectItems');
    const _selectedItems: any = JSON.parse(localStorage.getItem('selectedItems') || '[]');
    // event.component.selectRows(_selectedItems, false);
  }

  rowPrepared(event: any) {
    if (event.rowType === 'data') {
      // event.component.selectRows(1);
      // console.log(event.data.lotid);
    }
  }

  pagingChange(event: any) {
    console.log('pagingChange');
  }

  constentReady(event: any) {
    // this.gridContainer.instance.selectRows(JSON.parse(localStorage.getItem('selectedItems')), true);
    // return false;
  }

  selectItem2(event: any, data: any, a: any) {
    if (!data.lotid) {
      return;
    }

    let _selectedItems = JSON.parse(localStorage.getItem('selectedItems') || '[]');

    _selectedItems = _selectedItems.filter((x) => {
      if (x.lotid !== data.lotid) {
        return x;
      }
    });

    if (event.value) {
      _selectedItems.push(data);
    }

    this.selectedItems = _selectedItems;
    this.storageService.setItem('selectedItems', JSON.stringify(_selectedItems));
  }

  checkIfChecked(lotid: string) {
    let _selectedItems: any = JSON.parse(localStorage.getItem('selectedItems') || '[]');
    if ( _selectedItems.length > 0) {
      _selectedItems = _selectedItems.filter((x: any) => {
        if (x.lotid ===  lotid) {
          return x;
        }
      });
    }
    return _selectedItems.length > 0;
  }

  getSessionVariables(event: any) {
    // getSessionVariables
    this.apiService.get('upcominevents.asp', false).then((response: any) => {
      console.log(response);
    });
  }

  viewVideo(src: string) {
    this.isModalVisible = true;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(src);
  }

  clearFilter(event: Event) {
    this.colorFrom.value = 0;
    this.colorTo.value = 0;
    this.clarityFrom.value = 0;
    this.clarityTo.value = 0;
    this.weightFrom.value = null;
    this.weightTo.value = null;
    this.refreshInventory();
    this.showFilterModal = false;
  }

  relaodPage() {
    document.location.reload();
  }

  test(event: Event) {
   //alert('aaaaaa');
  }

  focusByName(event: any, name: string) {
    const x = this[name].instance;
    x.focus();
  }

  submitSearch(event: any, name: string) {
    const x = this[name].instance;
  }
}
